export default "__VITE_ASSET__BlsuDc8P__"